import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TawkChatService {
	constructor(@Inject(DOCUMENT) private readonly document: Document) {}

	attachScript(): void {
		const tawkInitScript = this.document.createElement('script');

		tawkInitScript.type = 'text/javascript';
		tawkInitScript.text = `
            var Tawk_API = Tawk_API || {},
                Tawk_LoadStart = new Date();
            (function () {
                var s1 = document.createElement('script'),
                    s0 = document.getElementsByTagName('script')[0];
                s1.async = true;
                s1.src = 'https://embed.tawk.to/682b68adb3c3dc190a7089ee/1irkp1pkg';
                s1.charset = 'UTF-8';
                s1.setAttribute('crossorigin', '*');
                s0.parentNode.insertBefore(s1, s0);
            })();
		`;

		this.document.head.appendChild(tawkInitScript);
	}
}
